// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { ContractEntity } from '../../../entities/mdqx/contract.entity';
import {
    MutationChangeContractArgs,
    MutationCreateContractArgs,
    MutationDeleteContractArgs,
} from '../../../mdqx-graphql-types';

export enum ContractActionTypes {
    GetContractsRequest = '[Contracts] Get Request',
    GetContractsResponse = '[Contracts] Get Response',
    PostContractRequest = '[Contract] Post Request',
    PostContractResponse = '[Contract] Post Response',
    PatchContractRequest = '[Contract] Patch Request',
    PatchContractResponse = '[Contract] Patch Response',
    DeleteContractRequest = '[Contract] Delete Request',
    DeleteContractResponse = '[Contract] Delete Response',
}

export class GetContractsRequest implements Action {
    readonly type = ContractActionTypes.GetContractsRequest;
}

export class GetContractsResponse implements Action {
    readonly type = ContractActionTypes.GetContractsResponse;
    constructor(public Payload: ContractEntity[]) {}
}

export class PostContractRequest implements Action {
    readonly type = ContractActionTypes.PostContractRequest;
    constructor(public Payload: MutationCreateContractArgs) {}
}

export class PostContractResponse implements Action {
    readonly type = ContractActionTypes.PostContractResponse;
    constructor(public Payload: ContractEntity) {}
}

export class PatchContractRequest implements Action {
    readonly type = ContractActionTypes.PatchContractRequest;
    constructor(public Payload: MutationChangeContractArgs) {}
}

export class PatchContractResponse implements Action {
    readonly type = ContractActionTypes.PatchContractResponse;
    constructor(public Payload: ContractEntity) {}
}

export class DeleteContractRequest implements Action {
    readonly type = ContractActionTypes.DeleteContractRequest;
    constructor(public Payload: MutationDeleteContractArgs) {}
}

export class DeleteContractResponse implements Action {
    readonly type = ContractActionTypes.DeleteContractResponse;
    constructor(public Payload: number) {}
}

export type ContractActions =
    | GetContractsRequest
    | GetContractsResponse
    | PostContractRequest
    | PostContractResponse
    | PatchContractRequest
    | PatchContractResponse
    | DeleteContractRequest
    | DeleteContractResponse;
